/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { KeyValue } from '../models/key-value';
import { ClientBillingOptionsKeyValueDTO } from '../models/client-billing-options-key-value-dto';
import { AcceptedResponseBody } from '../models/accepted-response-body';
import { BulkUploadsState } from '../models/bulk-uploads-state';
@Injectable({
  providedIn: 'root',
})
class KeyValueService extends __BaseService {
  static readonly GetPath = '/KeyValue/{id}';
  static readonly GetClientBillingOptionsPath = '/KeyValue/ClientBillingOptions';
  static readonly DeleteBulkUploadStatePath = '/KeyValue/BulkUploadState';
  static readonly GetEmailStopStatePath = '/KeyValue/EmailStopState';
  static readonly UpdateEmailStopStatePath = '/KeyValue/EmailStopState/{newValue}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `KeyValueService.GetParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetResponse(params: KeyValueService.GetParams): __Observable<__StrictHttpResponse<KeyValue>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/KeyValue/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KeyValue>;
      })
    );
  }
  /**
   * @param params The `KeyValueService.GetParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  Get(params: KeyValueService.GetParams): __Observable<KeyValue> {
    return this.GetResponse(params).pipe(
      __map(_r => _r.body as KeyValue)
    );
  }

  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetClientBillingOptionsResponse(Authorization?: string): __Observable<__StrictHttpResponse<ClientBillingOptionsKeyValueDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/KeyValue/ClientBillingOptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ClientBillingOptionsKeyValueDTO>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetClientBillingOptions(Authorization?: string): __Observable<ClientBillingOptionsKeyValueDTO> {
    return this.GetClientBillingOptionsResponse(Authorization).pipe(
      __map(_r => _r.body as ClientBillingOptionsKeyValueDTO)
    );
  }

  /**
   * @param params The `KeyValueService.DeleteBulkUploadStateParams` containing the following parameters:
   *
   * - `state`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  DeleteBulkUploadStateResponse(params: KeyValueService.DeleteBulkUploadStateParams): __Observable<__StrictHttpResponse<AcceptedResponseBody>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.state;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/KeyValue/BulkUploadState`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AcceptedResponseBody>;
      })
    );
  }
  /**
   * @param params The `KeyValueService.DeleteBulkUploadStateParams` containing the following parameters:
   *
   * - `state`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  DeleteBulkUploadState(params: KeyValueService.DeleteBulkUploadStateParams): __Observable<AcceptedResponseBody> {
    return this.DeleteBulkUploadStateResponse(params).pipe(
      __map(_r => _r.body as AcceptedResponseBody)
    );
  }

  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetEmailStopStateResponse(Authorization?: string): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/KeyValue/EmailStopState`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetEmailStopState(Authorization?: string): __Observable<boolean> {
    return this.GetEmailStopStateResponse(Authorization).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `KeyValueService.UpdateEmailStopStateParams` containing the following parameters:
   *
   * - `newValue`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  UpdateEmailStopStateResponse(params: KeyValueService.UpdateEmailStopStateParams): __Observable<__StrictHttpResponse<AcceptedResponseBody>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/KeyValue/EmailStopState/${params.newValue}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AcceptedResponseBody>;
      })
    );
  }
  /**
   * @param params The `KeyValueService.UpdateEmailStopStateParams` containing the following parameters:
   *
   * - `newValue`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  UpdateEmailStopState(params: KeyValueService.UpdateEmailStopStateParams): __Observable<AcceptedResponseBody> {
    return this.UpdateEmailStopStateResponse(params).pipe(
      __map(_r => _r.body as AcceptedResponseBody)
    );
  }
}

module KeyValueService {

  /**
   * Parameters for Get
   */
  export interface GetParams {
    id: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for DeleteBulkUploadState
   */
  export interface DeleteBulkUploadStateParams {
    state?: BulkUploadsState;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for UpdateEmailStopState
   */
  export interface UpdateEmailStopStateParams {
    newValue: boolean;

    /**
     * Bearer token
     */
    Authorization?: string;
  }
}

export { KeyValueService }
